import { useState } from "react";
import { AbsoluteCenter, Box, Stack, Text, Button, Field, Input, Separator } from "@chakra-ui/react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { toaster } from "../components/ui/toaster";

export default function Dashboard() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);

	async function handleSubmit(e) {
		e.preventDefault();
		setLoading(true);
		try {
			await signInWithEmailAndPassword(auth, email, password);
		} catch (err) {
			toaster.create({
				title: "Invalid credentials.",
				type: "error",
			});
		} finally {
			setLoading(false);
		}
	}

	return (
		<Box position="relative" width="100%" height="100vh" overflow="hidden">
			<AbsoluteCenter width="100%" padding={4}>
				<Stack as="form" onSubmit={handleSubmit} gap={8} maxW={{ base: "full", sm: "sm" }} width="100%">
					<Stack gap={4}>
						<Text color="fg">Investor Dashboard</Text>
						<Separator />
					</Stack>
					<Stack gap={4}>
						<Field.Root>
							<Field.Label>Email</Field.Label>
							<Input
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="name@company.com"
								required
							/>
						</Field.Root>
						<Field.Root>
							<Field.Label>Password</Field.Label>
							<Input
								type="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								placeholder="••••••••"
								required
							/>
						</Field.Root>
						<Button type="submit" variant="solid" loading={loading}>
							Continue
						</Button>
					</Stack>
				</Stack>
			</AbsoluteCenter>
		</Box>
	);
}
